import {GlobalSearchCategory, GlobalSearchFilterType, GlobalSearchSortConfig} from '@global-search/data-access';
import {QueryCycleSortMarker} from '@global-data';
import {UsersQuerySortBy} from '@data-users';

// Define a type for the filter values within a category
export type CategoryFilters = Partial<Record<GlobalSearchFilterType, any>>; // Partial allows not all filters to be set initially

export type IGlobalSearchUiState = {
	isOpen: boolean;
	isFiltersPanelOpen: boolean;
	activeCategory: GlobalSearchCategory;
	searchTerms: Record<GlobalSearchCategory, string>;
	filters: Partial<Record<GlobalSearchCategory, CategoryFilters>>; // Added: Filters state per category
	sorting: Partial<Record<GlobalSearchCategory, GlobalSearchSortConfig>>; // Added: Sorting configuration per category
};

export const initialGlobalSearchUiState: IGlobalSearchUiState = {
	isOpen: false, // Keep or remove based on whether the search is a modal/popup
	isFiltersPanelOpen: false,
	activeCategory: GlobalSearchCategory.CYCLE,
	// Initialize search terms for each category
	searchTerms: {
		[GlobalSearchCategory.CYCLE]: '',
		[GlobalSearchCategory.USER]: '',
		[GlobalSearchCategory.USER_GROUP]: '',
	},
	filters: {}, // Added: Initial empty filters object
	sorting: {
		// Default sorting configuration per category
		[GlobalSearchCategory.CYCLE]: {sortBy: QueryCycleSortMarker.LastUpdate, sortDirection: 'desc'},
		[GlobalSearchCategory.USER]: {sortBy: UsersQuerySortBy.username, sortDirection: 'asc'},
		[GlobalSearchCategory.USER_GROUP]: {sortBy: 'default', sortDirection: 'asc'},
	},
};
